import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_ID, NgModule } from '@angular/core';
import {
	BrowserModule,
} from '@angular/platform-browser';

import { DatePipe, TitleCasePipe } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
	CMS_BASE_URL,
	EntryComponent,
	SPA_BASE_URL,
} from '@app/entry/entry.component';
// import { PagesModule } from '@app/pages/pages.module';
import { BrSdkModule } from '@bloomreach/ng-sdk';
import { environment } from '@env/environment';
import { FeaturesModule } from '@features/features.module';
import { IsExternalLinkPipe } from '@shared/pipes/is-external-link.pipe';
import { IsInternalLinkPipe } from '@shared/pipes/is-internal-link.pipe';
import { ParseUrlPipe } from '@shared/pipes/parse-url.pipe';
import { SharedModule } from '@shared/shared.module';
// import { CarouselModule } from 'ngx-owl-carousel-o';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TokenInterceptor } from './core/interceptors/token.interceptor';
import { TransferInterceptorService } from './core/interceptors/transfer.interceptor';
import { ResourceApiCacheInterceptor } from './core/interceptors/resource-api-cache.interceptor';
import { NAPipe } from './shared/pipes';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MAT_RIPPLE_GLOBAL_OPTIONS, RippleGlobalOptions } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxPaginationModule } from 'ngx-pagination';

export function initializer() {
	return () => {};
}

const globalRippleConfig: RippleGlobalOptions = {
	disabled: true,
};

@NgModule({
	declarations: [
		AppComponent,
		EntryComponent,
		ParseUrlPipe,
		IsExternalLinkPipe,
		IsInternalLinkPipe,
	],
	imports: [
		AppRoutingModule,
		BrowserModule,
		BrowserAnimationsModule,
		BrSdkModule,
		FeaturesModule,
		// PagesModule,
		SharedModule,
		// CarouselModule,
		// BrowserTransferStateModule,
		MatSnackBarModule,
		MatTooltipModule,
		NgxPaginationModule
		// ServiceWorkerModule.register('ngsw-worker.js', {
		// 	enabled: environment.production,
		// 	// Register the ServiceWorker as soon as the app is stable
		// 	// or after 30 seconds (whichever comes first).
		// 	registrationStrategy: 'registerWhenStable:30000',
		// }),
	],
	providers: [
		// { provide: APP_BASE_HREF, useValue: '/' },
		{ provide: APP_ID, useValue: 'mohawkFlooringApp' },
		{ provide: CMS_BASE_URL, useValue: environment.cmsBaseUrl },
		{ provide: SPA_BASE_URL, useValue: environment.spaBaseUrl },
		{
			provide: HTTP_INTERCEPTORS,
			useClass: TransferInterceptorService,
			multi: true,
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: ResourceApiCacheInterceptor,
			multi: true,
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: TokenInterceptor,
			multi: true,
		},
		{ provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: globalRippleConfig },
		NAPipe,
		TitleCasePipe,
		DatePipe,
	],
	bootstrap: [AppComponent],
})
export class AppModule {}
